// @flow

import { Button } from "../common";
import { Spacer } from "../../../components/common/Spacer";
import { useAuth } from "../../../../hooks/useAuth";
import { useVersion } from "../../../../hooks/version";
import { withRouter } from "react-router-dom";
import Drawer from "react-motion-drawer";
import Icon, { Icons } from "react-hp-icons";
import React, { useDispatch, useGlobal, useState } from "reactn";
import styled from "styled-components";
import { HistoryOutlined } from "@ant-design/icons";
import { ModalButton } from "views/components/ModalButton";
import { getColor } from "../../../resources/theme";
import { Anchor } from "views/components/Anchor";
import { ExitTemporaryUserModal } from "views/components/common/TemporaryUserPopUp";
import { useLogoutWithTemporaryUser } from "hooks/useLogoutWithTemporaryUser";
interface Props {
	open: boolean;
	close: Function;
}

const Menu = ({ open = false, close, history }: Props) => {
	const logout = useDispatch("logout");
	const [user] = useGlobal("user");
	const [config] = useGlobal("UIConfig");
	const { isLoggedIn, isLoggedInTemporary } = useAuth();
	const [showExitModal, setShowExitModal] = useState(false);
	const [buttonType, setButtonType] = useState("");
	const { actionWithTemporary } = useLogoutWithTemporaryUser();
	const { hideFaqsRedirect } = config;
	const onLogout = () => {
		if (isLoggedIn)
			logout().then(() => {
				history.push("/home");
				close();
			});
		if (!isLoggedIn) close();
		history.push("/welcome");
	};

	const goToFAQ = () => {
		history.push("/faq");
		closeDrawer();
	};

	const goToInvestors = () => {
		window.open("https://comercial.zeroq.cl/inversionistas", "_blank");
		closeDrawer();
	};

	const version = useVersion();

	const closeDrawer = useDispatch("closeDrawer");
	const openDrawer = useDispatch("openDrawer");

	const openExitModal = (type) => {
		setShowExitModal(true);
		setButtonType(type);
	};

	const logInWithRealUser = (type) => {
		actionWithTemporary(type);
		setShowExitModal(false);
		closeDrawer();
	};

	return (
		<>
			{showExitModal && (
				<ExitTemporaryUserModal
					setShowExitModal={setShowExitModal}
					logInWithRealUser={logInWithRealUser}
					buttonType={buttonType}
				/>
			)}
			<StyledDrawer
				open={open}
				drawerStyle={{ backgroundColor: "white" }}
				right
				onChange={() => {
					open ? closeDrawer() : openDrawer();
				}}
				isLoggedInTemporary={isLoggedInTemporary}
			>
				<Close onClick={() => close(false)}>
					<Icon type={Icons.close} size={2} />
				</Close>
				{!isLoggedInTemporary && (
					<>
						<Header>
							<Avatar>
								<Icon type={Icons.user} size={3} />
							</Avatar>
							<br></br>
							<h3>
								{isLoggedIn ? user.name : "Usuario invitado"}
							</h3>
							<p>{isLoggedIn && user.email}</p>
						</Header>
						<Wrapper>
							<Redirect onClick={onLogout}>
								<Button color="secondary" size="full">
									{isLoggedIn
										? "Cerrar sesión"
										: "Iniciar sesión"}
								</Button>
							</Redirect>
							<Spacer rows={2} />
							<Redirect onClick={goToInvestors}>
								<div className="drawer__wrapper-faq-container">
									Inversionistas
								</div>
							</Redirect>

							{!hideFaqsRedirect && (
								<>
									<Spacer rows={2} />
									<Redirect onClick={goToFAQ}>
										<div className="drawer__wrapper-faq-container">
											Preguntas Frecuentes
										</div>
									</Redirect>
								</>
							)}

							<Spacer rows={10} />
							<Footer>{version}</Footer>
						</Wrapper>
					</>
				)}
				{isLoggedInTemporary && (
					<TemporaryUserComponent
						version={version}
						isLoggedInTemporary={isLoggedInTemporary}
						closeDrawer={closeDrawer}
						goToFAQ={goToFAQ}
						openExitModal={openExitModal}
					/>
				)}
			</StyledDrawer>
		</>
	);
};

export const TemporaryUserComponent = ({
	closeDrawer,
	isLoggedInTemporary,
	goToFAQ,
	openExitModal,
	version,
}) => {
	const [config] = useGlobal("UIConfig");
	const { hideFaqsRedirect } = config;
	return (
		<div>
			<Header isLoggedInTemporary={isLoggedInTemporary}>
				{/* <Close onClick={() => closeDrawer()}>
					<Icon type={Icons.close} size={2} />
				</Close> */}
				<Avatar isLoggedInTemporary={isLoggedInTemporary}>
					<HistoryOutlined style={{ fontSize: 42, color: "#fff" }} />
				</Avatar>
				<br></br>
				<h3>{"Usuario temporal"}</h3>
			</Header>
			<Wrapper>
				<span>
					¡Accede a tus sucursales favoritas, historial de tickets y
					más!
				</span>
				<Spacer rows={1} />

				<ButtonWrapper>
					<ModalButton
						loading={false}
						type={"primary"}
						label="Iniciar sesión"
						onClick={() => openExitModal("login")}
					/>
					<Spacer rows={0.5} />
					<ModalButton
						loading={false}
						type={"secondary"}
						label="Registrarse"
						onClick={() => openExitModal("register")}
					/>
				</ButtonWrapper>
				{!hideFaqsRedirect && (
					<>
						<Spacer rows={2} />
						<Redirect onClick={goToFAQ}>
							<div className="drawer__wrapper-faq-container">
								Preguntas Frecuentes
							</div>
						</Redirect>
					</>
				)}

				<Spacer rows={0.5} />
				<Anchor link={"https://comercial.zeroq.cl/"}>
					<div className="drawer__wrapper-faq-container">
						ZeroQ para empresas
					</div>
				</Anchor>
				<Spacer rows={10} />
				<Footer>{version}</Footer>
			</Wrapper>
		</div>
	);
};

const StyledDrawer = styled(Drawer)`
	& p {
		text-align: left;
		font-weight: ${(props) => (props.isLoggedInTemporary ? 500 : "normal")};
	}

	& span {
		text-align: left;
	}

	& a {
		color: #000;
		font-weight: 800;
	}
`;

const ButtonWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	& button {
		width: 80%;
	}
`;

const Close = styled.div`
	margin-left: auto;
	cursor: pointer;
	text-align: right;
	background-color: #dedede;
	padding: 10px;
	& svg {
		width: 18px;
	}
`;

const Avatar = styled.div`
	position: relative;
	width: 100px;
	height: 100px;
	overflow: hidden;
	border-radius: 50%;
	box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.3);
	background: ${(props) => {
		return props.isLoggedInTemporary ? props.theme.colors.blue_bg : "";
	}};
	& svg {
		position: absolute;
		top: 30px;
		left: 29px;
	}
`;

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	z-index: 100;
	overflow: hidden;
	align-items: center;
	padding: 20px;
	height: 100%;

	& .drawer__wrapper-faq-container {
		cursor: pointer;
	}
	& .drawer__wrapper-faq-container:hover {
		color: #274aa8;
	}
`;

const Header = styled.div`
	background: #dedede;
	margin-bottom: 10px;
	display: flex;
	flex-direction: column;
	z-index: 100;
	overflow: hidden;
	align-items: center;
	padding: 20px;
	& h3 {
		color: ${(props) =>
			props.isLoggedInTemporary ? props.theme.colors.blue_bg : ""};
		font-weight: normal;
	}
`;

const Footer = styled.div`
	color: #ddd;
`;

const Redirect = styled.div`
	font-weight: 800;
	&:hover {
		cursor: pointer;
	}
`;

export default withRouter(Menu);
